import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Finally, a practical use case for JavaScript generators!",
  "description": "",
  "published": "2019-04-17T00:00:00.000Z",
  "redirect_from": ["/blog/finally-a-practical-use-case-for-javascript-generators/swizec/9036"],
  "categories": "Front End, Livecoding, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`JavaScript generators are amazing. A brilliant concept infinitely useful on paper.`}</p>
    <p>{`They let you write infinite loops that terminate. Yield values from functions before they finish. Build lazy data structures. Lazy evaluation programming!`}</p>
    <p>{`A functional programmer's wet dream. 😍`}</p>
    <p>{`And I bet you've never used a JavaScript generator even once did you? Do you even know the syntax?`}</p>
    <p>{`I bet you don't.`}</p>
    <p>{`Turns out generators aren't very useful in practice. 😢`}</p>
    <p>{`But yesterday, after years of knowing about generators, years of itching to use them, years of ... I FOUND A USE! A real world practical use-case where generators `}<em parentName="p">{`actually`}</em>{` make your code better. 😱`}</p>
    <lite-youtube {...{
      "videoid": "XSHwIQUrD8E",
      "videostartat": "1411"
    }}></lite-youtube>
    <p>{`We were adding automatic linking of twitter usernames to my `}<a parentName="p" {...{
        "href": "https://techletter.app"
      }}>{`TechLetterApp`}</a>{` project. Find a piece of text, parse out `}<inlineCode parentName="p">{`@username`}</inlineCode>{` instances, turn into links.`}</p>
    <p>{`Easy right?`}</p>
    <p>{`I thought so too. Complications around inserting complex nodes into an abstract syntax tree (AST) aside, parsing those usernames is hard to do elegantly.`}</p>
    <p>{`Unless you use generators 😛`}</p>
    <h2 {...{
      "id": "heres-how-we-did-it-"
    }}>{`Here's how we did it 👇`}</h2>
    <p>{`First, you create a regex that matches `}<inlineCode parentName="p">{`@`}</inlineCode>{` followed by a series of word symbols.`}</p>
    <pre><code parentName="pre" {...{}}>{`<code class="javascript">const UserRegex = new RegExp(/@(\\w+)/, "g");
`}</code></pre>
    <p>{`Then you create a generator that runs this regex in a loop. Each `}<inlineCode parentName="p">{`UserRegex.exec()`}</inlineCode>{` returns the next match.`}</p>
    <pre><code parentName="pre" {...{}}>{`<code class="javascript">function* getUsernames(string) {
    let match = null;

    do {
        match = UserRegex.exec(string);
        if (match) {
            yield match;
        }
    } while (match);
}
`}</code></pre>
    <p>{`We have a `}<inlineCode parentName="p">{`*getUsernames`}</inlineCode>{` generator that takes a `}<inlineCode parentName="p">{`string`}</inlineCode>{`. The asterisk notation changes a function to a generator.`}</p>
    <p>{`Inside, a loop runs as long as `}<inlineCode parentName="p">{`match`}</inlineCode>{` has a value. Assigned on each iteration as a `}<inlineCode parentName="p">{`UserRegex.exec`}</inlineCode>{` call.`}</p>
    <p>{`We `}<inlineCode parentName="p">{`yield`}</inlineCode>{` existing values on every loop iteration. Last one will be `}<inlineCode parentName="p">{`null`}</inlineCode>{` and we don't want to return those.`}</p>
    <p>{`Yield is how you return values from generators. Notice that even after returning a value, the generator keeps running. That's the generator magic 🧙‍♀️`}</p>
    <p>{`You can now find all usernames in a string with a loop.`}</p>
    <pre><code parentName="pre" {...{}}>{`<code class="javascript">const string = "this is a test with @swizec and @kyleshevlin, maybe @lukeed05"

for (const username of getUsernames(string)) {
  console.log(username)
}
`}</code></pre>
    <p>{`That outputs`}</p>
    <pre><code parentName="pre" {...{}}>{`["@swizec", "swizec"]
["@kyleshevlin", "kyleshevlin"]
["@lukeed05", "lukeed05"]
`}</code></pre>
    <p><img parentName="p" {...{
        "src": "/9a021a6cd72cfaab539f3b1fef648ed9/media-12NUbkX6p4xOO4-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`Here's a CodeSandbox you can play with`}</p>
    <iframe {...{
      "src": "https://codesandbox.io/embed/lr800pko5m",
      "style": {
        "width": "100%",
        "height": "500px",
        "border": "0",
        "borderRadius": "4px",
        "overflow": "hidden"
      },
      "allow": "accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr; xr-spatial-tracking",
      "sandbox": "allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts"
    }}></iframe>
    <p>{`Cheers, ~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      